import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';
import { omit, pick } from 'lodash';
import Model from 'models/Model';

export async function entityTranslationSaveApi(body?: Api.Core.EntityTranslation.Save.IRequest) {
  const serverResponse = await executeServerApi<
    Api.Core.EntityTranslation.Save.IRequest,
    Api.Core.EntityTranslation.Save.IResponse,
    Api.Core.EntityTranslation.Save.IHeaders
  >({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url: '/api/Localization/EntityTranslation',
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export async function entityTranslationListApi(
  body?: Api.Core.EntityTranslation.List.IRequest & Api.Core.EntityTranslation.List.IParams
) {
  return await executeServerApi<
    Api.Core.EntityTranslation.List.IRequest,
    Api.Core.EntityTranslation.List.IResponse,
    Api.Core.EntityTranslation.List.IHeaders
  >({
    method: HttpMethod.get,
    url: createPathFromRoute('/api/Localization/EntityTranslation/:entityType', pick(body, 'entityType')),
    body: omit(body, 'entityType'),
    headers: getDefaultHeaders(),
  });
}
export async function entityTranslationDeleteApi(body: Api.Core.EntityTranslation.Delete.IRequest) {
  const serverResponse = await executeServerApi<
    Api.Core.EntityTranslation.Delete.IRequest,
    Api.Core.EntityTranslation.Delete.IResponse,
    Api.Core.EntityTranslation.Delete.IHeaders
  >({
    method: HttpMethod.delete,
    url: createPathFromRoute('/api/Localization/EntityTranslation/:id', body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export default class EntityTranslation
  extends Model<Model.IEntityTranslation>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IEntityTranslation>
{
  id: number;
  entityId: number;
  entityType: Utils.EntityTranslationType;
  languageIsoCode: Locale.Languages;
  propertyValues: Record<string, string>;

  constructor(
    data: Partial<Model.IEntityTranslation> | Utils.FormData<Model.IEntityTranslation>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.entityType || this.id?.toString(),
    };
  }

  static async list(body?: Api.Core.EntityTranslation.List.IRequest & Api.Core.EntityTranslation.List.IParams) {
    const { payload, ...rest } = await entityTranslationListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new EntityTranslation(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await entityTranslationSaveApi(this);
  }
  async delete() {
    return await entityTranslationDeleteApi({ id: this.id });
  }
}
